import React, {useState, useMemo} from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import { url } from '../../utils/variables';

export default function SearchablePicker({
    col = 6,
    label,
    value,
    data,
    placeholder,
    titleKey,
    valueKey,
    rtl,
    taggable,
    onSelect,
    required,
    disabled,
    fixed = false,
    hasIcon = false,
    brandKey,
    ...rest
    }) {
    const [picker, setPicker] = useState(false);
    const [options, setOptions] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const { t } = useTranslation();
    // const [carBrand,setCarBrand] = useState(null)
    // function getBrand(item) {
    //     setCarBrand(item.brand_id)
    //     return item[valueKey]
    // }
    const items = useMemo(() => {
        const hasTitleValue = titleKey && valueKey;
        return data.map(item => ({
            label: hasTitleValue ? item[titleKey] : item,
            value: hasTitleValue ? item[valueKey] : item,
            brand: brandKey ? item[brandKey] : ''
        }))
    }, [data, titleKey, valueKey ,brandKey]);
    
    const defaultValue = useMemo(() => items.find(item => (fixed ? t(item.value) : item.value) === value) || {label: value}, [items, value]);
    const dataProps = useMemo(() => JSON.stringify({value, required, label}), [label, required, value]);

    function openModal() {
        disabled ? 
        setPicker(false)
        :
        setPicker(true);
        setOptions(items);
    }

    function search(val) {
        const searchVal = items.filter(itm => itm.label.includes(val));
        setOptions(searchVal);
        setSearchInput(val);
    }

    function selectItem(item) {
        setPicker(false);
        fixed ? onSelect(t(item.value)) : onSelect(item.value,item.brand);
        setSearchInput('');
    }

    function renderTag() {
        if (taggable && searchInput) {
            const found = items.find(item => item.label === searchInput);
            if (!found)
                return <button className='btn btn-yellow btn-sm add-btn' onClick={importTag}>{t('Add')}</button>
        }
        return <i className='fas fa-search'/>
    }

    function importTag() {
        setPicker(false);
        onSelect(searchInput);
        setSearchInput('');
    }

    return (
        <div className={`col-${col}`} {...rest} data-props={dataProps}>
            {
                label &&
                <div className='mt10 mb5'>
                    <label>
                        {
                            required &&
                            <span className='required-icon'>* </span>
                        }
                        {label}
                    </label>
                </div>
            }
            <div className='input-parent'>
                <div className={rtl ? 'searchablePicker rtl' : 'searchablePicker'}>
                    <div className={`input ${disabled ? 'disabled': ''}`} onClick={openModal}>
                        <div className='input-overflow'>
                            <span className='pickerText'>{
                                (fixed ? t(defaultValue.label) : defaultValue.label) 
                                // ||
                                // <span 
                                // // style={{color: '#777'}}
                                // >{placeholder || label}</span>
                            }</span>
                            {hasIcon && defaultValue.value && <span className='withIcon'><img src={`${url}/images/insurances/${defaultValue.value}.png`}/></span>}
                        </div>
                    </div>
                    <Modal visible={picker}>
                        <div className='picker-content p10 d-flex flex-column'>
                            <div className='input-parent withIcon'>
                                <input
                                    type='text'
                                    placeholder={t('Search')}
                                    value={searchInput}
                                    onChange={e => search(e.target.value)}
                                />
                                {renderTag()}
                            </div>
                            <ul>
                                {
                                    options.map((item, index) => (
                                        <li
                                            key={index}
                                            onClick={() => selectItem(item)}
                                            className={item.value === defaultValue.value ? 'selected' : ''}
                                        >
                                            {/* {item.label} */}
                                            {fixed ? t(item.label) : item.label}
                                            {hasIcon && <span className='withIcon'><img src={`${url}/images/insurances/${item.value}.png`}/></span>}
                                        </li>
                                    ))
                                }
                            </ul>
                            <button 
                                className='btn btn-orange btn-circle' 
                                onClick={() =>{ 
                                    setSearchInput('')
                                    setPicker(false)}}
                                >
                                {t('Reject')}
                            </button>
                        </div>
                    </Modal>
                </div>
            </div>
        </div>
    );

}
